import { useMemo } from 'react';
import { dimensionPageSize } from '../dimensions/page-size';
import { useGetApiTasksInfinite, } from './use-infinite-tasks';
export function useGetTasks(variables, options) {
    const result = useGetApiTasksInfinite({
        ...variables,
        queryParams: {
            ...variables.queryParams,
            pageNumber: '1',
            pageSize: `${dimensionPageSize}`,
        },
    }, options);
    const data = useMemo(() => result.data?.pages.flat(), [result.data]);
    const { hasNextPage, fetchNextPage, isFetchingNextPage, hasPreviousPage, fetchPreviousPage, isFetchingPreviousPage, ...rest } = result;
    return {
        ...rest,
        data,
    };
}
//# sourceMappingURL=use-get-tasks.js.map